import React from 'react'

export const AnchorLink = ({link}) => {
  return <span className={`visually-hidden anchor-link anchor-link-${link}`}>Anchor Link</span>
}
